import { type UseToastReturn, useToast } from '@piccolohealth/ui';
import type { QueryClient } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import type { AuthContextProps } from '../context/AuthContext';
import { useAuth } from '../context/AuthContext';
import type { ConfigContext } from '../context/ConfigContext';
import { useConfig } from '../context/ConfigContext';
import type { OrganizationContext } from '../context/OrganizationContext';
import { useOrganization } from '../context/OrganizationContext';
import type { UserContext } from '../context/UserContext';
import { useUser } from '../context/UserContext';

interface AppContextValue extends UseToastReturn, ConfigContext {
  location: Location;
  auth: AuthContextProps;
  user: UserContext;
  organization: OrganizationContext;
  queryClient: QueryClient;
}

const useGetContext = (): AppContextValue => {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const user = useUser();
  const organization = useOrganization();
  const toast = useToast();

  const config = useConfig();
  return {
    ...config,
    ...toast,
    location,
    auth,
    user,
    organization,
    queryClient,
  };
};

export const useAppContext = (): AppContextValue => {
  return useGetContext();
};
